import angular from 'angular';
import template from './template.html';
import './style.scss';
import {
    TFTSelect,
} from '../tft-select';

export class TFTTagsInput extends TFTSelect {
    values = [];
    innerValue = '';
    options = [];
    onOptionSelect = () => {};

    isSingleSelect = false;
    isInputFocused = false;
    placeholder = '';
    label = '';

    /* @ngInject */
    constructor($timeout) {
        super();
        this.$timeout = $timeout;
    }

    $onChanges(...args) {
        super.$onChanges(...args);
    }

    onValueChange() {
        this.onInputChange({ inputValue: this.innerValue });
    }

    onOptionClick(option, event) {
        event.stopPropagation();

        if (!this.values.some(({ value }) => value === option.value)) {
            this.values.push({ ...option });
            this.onValuesChange({ values: angular.copy(this.values) });
        }

        super.onOptionClick(option);
        this.setShownState(false);
    }

    onInputFocus() {
        this.setShownState(true);
        this.isInputFocused = true;
    }

    onInputBlur() {
        this.isInputFocused = false;
    }

    onTagDelete(option, event) {
        event.stopPropagation();
        this.innerValue = '';
        this.values = this.values.filter(({ value }) => value !== option.value);
        this.onValuesChange({ values: angular.copy(this.values) });
        this.$timeout(() => {
            angular.element(`#${this.inputId}`).focus();
        });
    }
}

export const TFTTagsInputConfiguration = {
    template,
    bindings: {
        values: '<',
        options: '<',
        isInvalid: '<',
        required: '<',
        isLoading: '<',
        onValuesChange: '&',
        onInputChange: '&',
        isSingleSelect: '<',
        placeholder: '@',
        label: '@',
        inputId: '@',
    },
    controller: TFTTagsInput,
    controllerAs: 'tftTagsInputCtrl',
};

angular
    .module('TALENYA-FE')
    .component('tftTagsInput', TFTTagsInputConfiguration);
